module.exports = __webpack_public_path__ + "img/Qstempel.11bd9012.png";